import React from 'react';
import { MDBPagination, MDBPaginationItem, MDBPaginationLink } from 'mdb-react-ui-kit';

const Pagination = ({ offsetPage, setOffsetPage, totalPages, lastPage }) => {

  if (totalPages === 0 || totalPages === 1) {
    return null;
  }

  let pageNumbers = [];

  if (totalPages <= 10) {
    pageNumbers = Array.from({ length: totalPages }, (_, index) => index);
  } else {
    const startPage = Math.max(0, offsetPage - 2);
    const endPage = Math.min(totalPages - 1, offsetPage + 2);
    
    pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

    if (pageNumbers[0] > 0) {
      pageNumbers.unshift(0); 
    }

    if (pageNumbers[pageNumbers.length - 1] < totalPages - 1) {
      pageNumbers.push(totalPages - 1); 
    }
  }

  const handlePrevious = () => {
    if (offsetPage > 0) {
      setOffsetPage(offsetPage - 1);
    }
  };

  const handleNext = () => {
    if (!lastPage) {
      setOffsetPage(offsetPage + 1);
    }
  };

  return (
    <nav>
      <MDBPagination className='mb-0 d-flex justify-content-end'>
        <MDBPaginationItem disabled={offsetPage === 0}>
          <MDBPaginationLink
            className='mx-1'
            onClick={handlePrevious}
            title={offsetPage === 0 ? "No more previous pages" : undefined}
            style={offsetPage === 0 ? { cursor: 'not-allowed' } : undefined}
          >
            Previous
          </MDBPaginationLink>
        </MDBPaginationItem>

        {pageNumbers.map(pageNumber => (
          <MDBPaginationItem key={pageNumber} active={pageNumber === offsetPage}>
            <MDBPaginationLink onClick={() => { setOffsetPage(pageNumber) }}>
              {pageNumber + 1}
            </MDBPaginationLink>
          </MDBPaginationItem>
        ))}

        <MDBPaginationItem disabled={lastPage}>
          <MDBPaginationLink
            className='mx-1'
            onClick={handleNext}
            style={lastPage ? { cursor: 'not-allowed' } : undefined}
          >
            Next
          </MDBPaginationLink>
        </MDBPaginationItem>
      </MDBPagination>
    </nav>
  );
};

export default Pagination;